exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.aims hr[data-v-51cf400b] {\n  max-width: unset;\n}\n.aims img[data-v-51cf400b] {\n  max-width: 240px;\n}\n", ""]);

// exports
